import { createSelector } from 'reselect';

import { selectStore } from './view';

export const selectTDO = createSelector(selectStore, (s) => s && s.tdo);

/**
 * The media currently being viewed, as recorded when its load started.
 *
 * Use this — not `selectTDO()?.id` — to decide whether something that arrived
 * late still belongs to what is open: `tdo` lags by one action, because
 * IN_SET_TDO follows IN_LOAD_MEDIA_DATA.
 */
export const selectCurrentTdoId = createSelector(
  selectStore,
  (s) => s?.currentTdoId
);
